module.exports = __webpack_public_path__ + "img/osfatun-2.402abe4b.svg";